import { UserBooking } from '../../user-bookings/schemas'
import { REVIEW_CUTOFF_DAYS } from './consts'

export abstract class UserCanAdd {
  protected today: Date

  constructor() {
    this.today = new Date()
    this.today.setHours(0, 0, 0, 0)
  }

  abstract check(
    userBookings: UserBooking[],
    campsiteSlug: string,
    token?: string,
  ): UserBooking

  protected getCutOffDate(baseDate: string) {
    const cutOffDate = new Date(baseDate)
    cutOffDate.setHours(0, 0, 0, 0)
    cutOffDate.setDate(new Date(baseDate).getDate() + REVIEW_CUTOFF_DAYS)
    return cutOffDate
  }
}
